import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';

@Component({
  selector: 'app-gip-company-list',
  templateUrl: './gipCompanyList.component.html',
  styleUrls: ['./gipCompanyList.component.css']
})
export class GipCompanyListComponent implements OnInit {

  constructor(private router: Router,
    private shareData: SharingDataService,
    public translateResourceDefinition: TranslateResourceDefinitionPipe,
  ) { }

  urlString = "Admin/MS_COMPANY"
  resourceDefinition: any;

  columns = [
    { name: "MID", visible: false, enableFilter: true, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: true, picklistTableName: null, function: 'toCompanyPage', CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "COMPANY", visible: true, enableFilter: true, enableOrderBy: true, export: true, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: 'toCompanyPage', CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "STREET", visible: true, enableFilter: true, enableOrderBy: true, export: true, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: 'toCompanyPage', CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "HOUSE_NUMBER", visible: true, enableFilter: true, enableOrderBy: true, export: true, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: 'toCompanyPage', CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "CITY", visible: true, enableFilter: true, enableOrderBy: true, export: true, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: 'toCompanyPage', CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "UNUSED", visible: true, enableFilter: true, enableOrderBy: true, export: true, type: "checkbox", columnSearch: false, fromToFilter: false, picklistTableName: "V_GIP_NUMBOOL_VL_T", function: 'toCompanyPage', CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
  ];

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe((data) => this.resourceDefinition = data);
  }

  action(parameters) {
    this[parameters.action](parameters.element, parameters.column);
  }

  toCompanyPage(element, column) {
    this.router.navigate(["/gipCompanyForm"], { queryParams: { id: element.MID, isEdit: true }, queryParamsHandling: 'merge' });

  }

  btnAddAction() {
    this.router.navigate(["/gipCompanyForm"]);
  }

}
